import React from 'react';

interface TooltipEntry {
  name: string;
  value: number;
  color: string;
}

interface Props {
  active?: boolean;
  payload?: TooltipEntry[];
  label?: string;
}

const SortedTooltip = ({ active, payload, label }: Props) => {
  if (!active || !payload?.length) return null;

  const sorted = [...payload].sort((a, b) => (b.value ?? 0) - (a.value ?? 0));

  return (
    <div className="bg-white border border-gray-200 rounded shadow p-2 text-sm">
      <p className="font-semibold text-gray-700 mb-1">{label}</p>
      {sorted.map((entry) => (
        <p key={entry.name} style={{ color: entry.color }}>
          {entry.name}: {entry.value}
        </p>
      ))}
    </div>
  );
};

export default SortedTooltip;
